import VueRouter from "vue-router";

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};

import index from "./components/index";
import subject from "./components/subject";
import importantBusiness from "./components/importantBusiness";
import position from "./components/position";
import law from "./components/law";
import download from "./components/download";
import link from "./components/link";
import tissue from "./components/tissue";
import notFound from "./components/notFound";
import leaderTrainingCampApplicant from "./components/leaderTrainingCamp/applicant";
import leaderTrainingCampIndex from "./components/leaderTrainingCamp/index";
let routes = [
  // by Allen
  {
    path: "/notFound",
    name: "notFound",
    component: notFound,
  },
  {
    path: "/",
    name: "index",
    component: index,
  },
  {
    path: "/subject",
    name: "subject",
    component: subject,
    props: true,
  },
  {
    path: "/importantBusiness",
    name: "importantBusiness",
    component: importantBusiness,
    props: true,
  },
  {
    path: "/position/:title",
    name: "position",
    component: position,
    props: true,
  },
  {
    path: "/law/:title",
    name: "law",
    component: law,
    props: true,
  },
  {
    path: "/link/:title",
    name: "link",
    component: link,
    props: true,
  },
  {
    path: "/download/:title",
    name: "download",
    component: download,
    props: true,
  },
  {
    path: "/tissue",
    name: "tissue",
    component: tissue,
  },
  //領導培訓營相關元件
  {
    path: "/leaderTrainingCamp/signup/:activityId",
    name: "leaderTrainingCamp.applicant",
    component: leaderTrainingCampApplicant,
  },
  {
    path: "/leaderTrainingCamp/applicant/:supplementId",
    name: "leaderTrainingCamp.applicant",
    component: leaderTrainingCampApplicant,
  },
  {
    path: "/leaderTrainingCamp/index",
    name: "leaderTrainingCamp.index",
    component: leaderTrainingCampIndex,
  },
  //其他
  {
    path: "",
    redirect: "/",
  },
  {
    path: "/index",
    redirect: "/",
  },
  {
    path: "*",
    redirect: "/notFound",
  },
];

export default new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
